function initTable() {
	tableEnlarge();
	tableCollapsible();
}
